import { DocumentsLookupView } from '../../../orders/order';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import React from 'react';

const Row = ({ document, onDownload, downloadingId }) => {
  const { orderId, documentId, name, fullDocumentId, isLegacy } = document;
  const isDownloading = fullDocumentId === downloadingId;
  return (
    <tr>
      <td>
        {name}
        <Button
          className="btn btn-outline-primary ms-3"
          onClick={(e) =>
            onDownload(orderId, documentId, fullDocumentId, isLegacy)
          }
        >
          {isDownloading && (
            <span>
              Downloading <i className="fa fa-spin fa-spinner" />
            </span>
          )}
          {!isDownloading && (
            <span>
              Download <i className="fa fa-download" />
            </span>
          )}
        </Button>
      </td>
    </tr>
  );
};

Row.propTypes = {
  document: PropTypes.instanceOf(DocumentsLookupView).isRequired,
  onDownload: PropTypes.func.isRequired,
  downloadingId: PropTypes.string,
};

export default Row;
